import type {
	UserDetails,
	UserGoogleLogin,
	UserLogin,
	ApiResponse,
} from "@vita-learning/types";

import { resHttpClient as httpClient } from "~/shared/services";
import { makeUrl } from "~/shared/utils";

interface LoginCredentialsOptions {
	readonly provider: "credentials";
}

interface LoginGoogleOptions {
	readonly provider: "google";
}

// biome-ignore lint/correctness/noUnusedVariables: Future use
interface LoginMicrosoftOptions {
	readonly provider: "microsoft";
}

// biome-ignore lint/correctness/noUnusedVariables: Future use
interface LoginTiktokOptions {
	readonly provider: "tiktok";
}

/**
 *
 * @param user
 * @param options
 * @returns
 */
export function loginUser(
	user: UserGoogleLogin,
	options: LoginGoogleOptions
): Promise<UserDetails>;
export function loginUser(
	user: UserLogin,
	options: LoginCredentialsOptions
): Promise<UserDetails>;
export async function loginUser(
	user: UserLogin | UserGoogleLogin,
	options: LoginCredentialsOptions | LoginGoogleOptions
): Promise<UserDetails> {
	const url = makeUrl("/access-tokens");

	url.searchParams.set("provider", options.provider);

	const resp = await httpClient.post<ApiResponse<UserDetails>>(
		url.pathname + url.search,
		user
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
}

/**
 *
 * @param props
 */
export const logoutUser = () =>
	httpClient.delete("/access-tokens", {
		// Try to force the request to go through
		retries: 3,
	});
